export default () => ({
  campaign: {},
  updateCv: null
})
